// import { transformResponse } from '../transformer';
import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/item-saga/dice-skins';

const diceSkinApi = {
    index: async () => {
        const { data } = await http.get(`${API_PREFIX}`);

        return data;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);
        return data;
    },

    update: async (id, body) => {
        await http.patch(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

export default diceSkinApi;
